// extracted by mini-css-extract-plugin
module.exports = {"GlobalSpinner":"Spinners_GlobalSpinner__3x4_t","SpinnerElement":"Spinners_SpinnerElement__jmlX-","LocalSpinner":"Spinners_LocalSpinner__25ghW"};